(ns net.kestec.mhda-pilgrimage.cms.cms
  (:require
    [ajax.core :as ajax]
    [net.kestec.mhda-pilgrimage.db :as db]
    [re-frame.core :as rf]
    [reagent.core :as r]
    [reagent.ratom :as ra]))

(rf/reg-event-fx
  ::load-storage
  (fn [_ [_ storage]]
    {:http-xhrio {:method :get
                  :uri storage
                  :response-format (ajax/text-response-format)
                  :on-success      [::db/update! [::storage] assoc storage]
                  :on-failure      [::db/update! [::storage] #(assoc % storage "<p></p>")]}}))

(rf/reg-sub-raw
  ::storage-content
  (fn [db-ref [_ storage]]
    (rf/dispatch [::load-storage storage])
    (ra/make-reaction
      (fn [] (get-in @db-ref [::storage storage]))
      :on-dispose #(rf/dispatch [::db/update! [::storage] dissoc storage]))))

(defn view [document-slot & {:html/keys [tag]
                             :disaster/keys [id]
                             :or {tag :div}
                             :as extra-attrs}]
  [tag (assoc (dissoc extra-attrs :html/tag :disaster/id)
         :dangerouslySetInnerHTML
         (r/unsafe-html
           @(rf/subscribe
              [::storage-content
               (str "/api/disaster/"
                    (or id (:disaster/id @(rf/subscribe [::db/selected-disaster])))
                    "/doc/" document-slot)])))])
